import { render, staticRenderFns } from "./WxbookFriend.vue?vue&type=template&id=0c79c294&scoped=true&"
import script from "./WxbookFriend.vue?vue&type=script&lang=js&"
export * from "./WxbookFriend.vue?vue&type=script&lang=js&"
import style0 from "./WxbookFriend.vue?vue&type=style&index=0&id=0c79c294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c79c294",
  null
  
)

export default component.exports